import { Box, Stack, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import EnrichmentInfoStep from '@app/src/pages/ResourceCollection/Collections/Provider/ScheduleEnrichment/EnrichmentInfoStep'

type EnrichmentStepProps = {
  successfulRows: number
  isScheduling: boolean
  onScheduleEnrichment: (enabled: boolean) => void
  hasProviderIds?: boolean
}

const EnrichmentStep: React.FC<EnrichmentStepProps> = ({
  successfulRows,
  isScheduling,
  onScheduleEnrichment,
  hasProviderIds = false,
}) => {
  const { formatMessage } = useIntl()
  const [enrichmentEnabled, setEnrichmentEnabled] = useState(true)

  const handleSubmit = () => {
    onScheduleEnrichment(enrichmentEnabled)
  }

  return (
    <Stack spacing={4}>
      <Box>
        <Typography variant="h4" gutterBottom>
          {formatMessage({ id: 'import.enrichment.title' })}
        </Typography>
        <Typography variant="body1" color="textSecondary">
          {formatMessage({ id: 'import.enrichment.description' })}
        </Typography>
      </Box>

      <EnrichmentInfoStep
        selectedCount={successfulRows}
        isEnrichmentEnabled={enrichmentEnabled}
        onEnrichmentToggle={setEnrichmentEnabled}
        isLoading={isScheduling || !hasProviderIds}
        onSubmit={handleSubmit}
      />
    </Stack>
  )
}

export default EnrichmentStep
